// extracted by mini-css-extract-plugin
export default {"descriptionList":"DescriptionList_descriptionList__j7GQQ","compact":"DescriptionList_compact__93THd"};